export default "__VITE_ASSET__iolh9ajd__"